import { returnsApiProxy } from '@/redux/api/returns-api-slice'
import type { ReturnsApiGetOrderRequest } from '@itsrever/rever-api'
import { useMutation } from '@tanstack/react-query'

const authenticateOrder = async (req: ReturnsApiGetOrderRequest) => {
  const { data } = await returnsApiProxy.getOrder(req)

  return data
}

export const useAuthenticateOrder = () => {
  return useMutation({
    mutationFn: authenticateOrder
  })
}
